__turbopack_context__.v({
  "avatar": "ReviewPlatformProofModule-module__oNlqtG__avatar",
  "brandHeading": "ReviewPlatformProofModule-module__oNlqtG__brandHeading",
  "brandMark": "ReviewPlatformProofModule-module__oNlqtG__brandMark",
  "card": "ReviewPlatformProofModule-module__oNlqtG__card",
  "carousel": "ReviewPlatformProofModule-module__oNlqtG__carousel",
  "controls": "ReviewPlatformProofModule-module__oNlqtG__controls",
  "counter": "ReviewPlatformProofModule-module__oNlqtG__counter",
  "eyebrow": "ReviewPlatformProofModule-module__oNlqtG__eyebrow",
  "facebook": "ReviewPlatformProofModule-module__oNlqtG__facebook",
  "fallback": "ReviewPlatformProofModule-module__oNlqtG__fallback",
  "google": "ReviewPlatformProofModule-module__oNlqtG__google",
  "googleMark": "ReviewPlatformProofModule-module__oNlqtG__googleMark",
  "header": "ReviewPlatformProofModule-module__oNlqtG__header",
  "icon": "ReviewPlatformProofModule-module__oNlqtG__icon",
  "iconOnlyLink": "ReviewPlatformProofModule-module__oNlqtG__iconOnlyLink",
  "linkedin": "ReviewPlatformProofModule-module__oNlqtG__linkedin",
  "linkedinStats": "ReviewPlatformProofModule-module__oNlqtG__linkedinStats",
  "metrics": "ReviewPlatformProofModule-module__oNlqtG__metrics",
  "module": "ReviewPlatformProofModule-module__oNlqtG__module",
  "navigation": "ReviewPlatformProofModule-module__oNlqtG__navigation",
  "rating": "ReviewPlatformProofModule-module__oNlqtG__rating",
  "ratingOnly": "ReviewPlatformProofModule-module__oNlqtG__ratingOnly",
  "review": "ReviewPlatformProofModule-module__oNlqtG__review",
  "reviewLink": "ReviewPlatformProofModule-module__oNlqtG__reviewLink",
  "reviewMeta": "ReviewPlatformProofModule-module__oNlqtG__reviewMeta",
  "reviewer": "ReviewPlatformProofModule-module__oNlqtG__reviewer",
  "skeleton": "ReviewPlatformProofModule-module__oNlqtG__skeleton",
  "sources": "ReviewPlatformProofModule-module__oNlqtG__sources",
  "stars": "ReviewPlatformProofModule-module__oNlqtG__stars",
  "stat": "ReviewPlatformProofModule-module__oNlqtG__stat",
  "statLink": "ReviewPlatformProofModule-module__oNlqtG__statLink",
  "status": "ReviewPlatformProofModule-module__oNlqtG__status",
  "summaryCount": "ReviewPlatformProofModule-module__oNlqtG__summaryCount",
  "summaryDate": "ReviewPlatformProofModule-module__oNlqtG__summaryDate",
  "summaryDetail": "ReviewPlatformProofModule-module__oNlqtG__summaryDetail",
  "summaryGrid": "ReviewPlatformProofModule-module__oNlqtG__summaryGrid",
  "summaryHeader": "ReviewPlatformProofModule-module__oNlqtG__summaryHeader",
});
